export default __webpack_public_path__ + "static/OpenSans-VariableFont_wdth,wght-a42bbe687810bdc6e9e83f1ec1884375.ttf";